import { clean, num, stripHtml } from './format';
export interface Poi {
  poi_name?: string;
  poi_type?: string;
  poi_address?: string;
  poi_latitude?: string;
  poi_longitude?: string;
  poi_short_description?: string;
  poi_featured_image?: string;
  poi_business_url?: string;
  poi_directions_map_url?: string;
  poi_place_primary_type?: string;
  poi_miles_from_property?: string;
  poi_walking_minutes?: string;
  poi_driving_minutes?: string;
}

export const miles = (p: Poi) => num(p.poi_miles_from_property);
export const byDist = (a: Poi, b: Poi) => (miles(a) ?? 99) - (miles(b) ?? 99);

const mins = (s: unknown) => {
  const m = String(s || '');
  const h = /(\d+)\s*hour/.exec(m);
  const mm = /(\d+)\s*min/.exec(m);
  if (!h && !mm) return null;
  return (h ? +h[1] * 60 : 0) + (mm ? +mm[1] : 0);
};
const fmtMin = (n: number) => (n >= 60 ? `${Math.floor(n / 60)} hr${n % 60 ? ` ${n % 60} min` : ''}` : `${n} min`);

/** Walk times are generated for any distance, so a walk only shows when it is a real one. */
const WALK_MAX = 30;

export function travel(p: Poi): string {
  const out: string[] = [];
  const d = mins(p.poi_driving_minutes);
  const w = mins(p.poi_walking_minutes);
  if (d != null) out.push(`${fmtMin(d)} drive`);
  if (w != null && w <= WALK_MAX) out.push(`${fmtMin(w)} walk`);
  return out.join(' · ');
}

export function directions(p: Poi): string | null {
  const own = clean(p.poi_directions_map_url);
  if (own) return own;
  const lat = clean(p.poi_latitude);
  const lng = clean(p.poi_longitude);
  if (lat && lng) return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${lat},${lng}`)}`;
  const addr = clean(p.poi_address);
  return addr ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addr)}` : null;
}

export function website(p: Poi): string | null {
  const u = clean(p.poi_business_url);
  return u && /^https?:\/\//i.test(u) ? u : null;
}

export const poiDesc = (p: Poi) => stripHtml(clean(p.poi_short_description) || '');

export function typeWords(t: unknown): string {
  const s = clean(t);
  if (!s) return '';
  const w = s.replace(/_/g, ' ');
  return w[0].toUpperCase() + w.slice(1);
}